import React from 'react';
import { Icon } from './Icon.js';
export const IconCodeActionFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,13c-.414,0-.75-.336-.75-.75V5.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v6.5c0,.414-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "3.5", r: "2.75", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "14.5", r: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconCodeActionFill18.js.map